<template>
    <nav class="panel bottom font-body fixed left-0 w-full z-50 text-center text-size2 pointer-events-none bottom-0 w-5 m-auto">
        <div class="sections">
            <div class="center">
                <h5 v-if="title" class="bottomTitle text-size1 font-bold font-anonymouse text-white uppercase tracking-spc6 mb-2 hover:opacity-100">{{title}}</h5>
                <span class="nextSlide block hover:opacity-100 cursor-pointer">
                    <svg id="arrow-down" viewBox="0 0 24 24" class="w-5 ml-auto mr-auto hover:opacity-100 hover:cursor-pointer">
                        <path d="M12 18c-.2 0-.5-.1-.7-.3l-11-10c-.4-.4-.4-1-.1-1.4.4-.4 1-.4 1.4-.1l10.4 9.4 10.3-9.4c.4-.4 1-.3 1.4.1.4.4.3 1-.1 1.4l-11 10c-.1.2-.4.3-.6.3z"></path>
                    </svg>
                </span>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        props: ['title'],
        name: "NextButton"
    }
</script>

<style scoped>

</style>